import React from 'react';
import { Box } from '@mui/material';
import { Heading, BodyText } from '@lmig/lmds-react';

const Confirmation = () => {
    console.log('confirmation');
    return (
        <Box style={{ padding: '20px', maxWidth: '568px' }}>
            <Heading type='h2-light'>
                You’re all set!
            </Heading>
            <BodyText type='article' style={{ font: 'roboto', fontSize: '16px' }}>
                Your claims rep will contact you in a few days to discuss your estimate changes. You can now close this tab. 
            </BodyText>            
        </Box>
    );
};

export default Confirmation;
